<template>
  <div>
    <h1>
      Conditions générales d'utilisation de la plateforme Ooftop<br />Dernière
      mise à jour&nbsp;: 2 janvier 2023
    </h1>
    <p>
      <strong
        >Merci de lire et d'accepter les conditions générales d'utilisation pour
        accéder à la plateforme d&rsquo;estimation immobilière Ooftop et au site
        internet Ooftop</strong
      >
    </p>
    <h2>ARTICLE 1 : Objet</h2>
    <p>
      Les présentes conditions générales d&rsquo;utilisation (ci-après dénommées
      « CGU ») s&rsquo;appliquent à toute utilisation du site internet et la
      plateforme d&rsquo;estimation immobilière Ooftop et de demande de
      documents qui y sont proposés (ci-après « Ooftop », le «&nbsp;Site&nbsp;»
      ou les «&nbsp;Services&nbsp;») par tout Utilisateur ou Client et disposant
      d&rsquo;un compte en ligne.
    </p>
    <p>
      Les CGU applicables sont celles en vigueur lors de la connexion et de
      l&rsquo;utilisation d&rsquo;Ooftop par l&rsquo;Utilisateur. Les CGU
      doivent être acceptées par tout Utilisateur, et son accès à Ooftop vaut
      acceptation de ces CGU.
    </p>
    <p>
      Ooftop est édité par la société IDANS DIGITAL (SAS au capital de 5.000 € -
      12, rue Saint-Fiacre – 75002 Paris – 843 534 132 RCS Paris) (ci-après «
      IDANS » ou «&nbsp;l&rsquo;Editeur&nbsp;») dont le numéro de TVA
      intracommunautaire est le FR60843534132.
    </p>
    <p>
      <strong>Directeur de la publication</strong>&nbsp;: Salomon
      BENARROCH<strong></strong>
    </p>
    <p>
      <strong>Contact&nbsp;: </strong
      ><a href="mailto:info@ooftop.fr">info@ooftop.fr</a>
    </p>
    <p>
      Le site internet Ooftop est hébergé par WP SERVEUR<br />
      Adresse web : https://www.wpserveur.net/<br />
      Adresse Postale : 7 rue de la Cité Foulc 30000 Nîmes<br />
      Formulaire de communication à suivre sur le site de WP SERVEUR.<br />
      La plateforme Ooftop est hébergée par FINACCA, 12, rue Saint-Fiacre –
      75002 Paris
    </p>
    <h2>ARTICLE 2 : Accès à Ooftop</h2>
    <p><strong>2.1 Consultation du site Ooftop</strong></p>
    <p>
      La consultation du site Ooftop est accessible gratuitement à tout Client
      disposant d&rsquo;un accès internet, sauf en cas d&rsquo;exercice du droit
      de Ooftop de procéder à toute interruption pour raison de maintenance
      technique nécessaire au bon fonctionnement du Site et des matériels
      afférents, ou de mise à jour du site. Le Client est seul responsable du
      bon fonctionnement de son équipement informatique ainsi que de son accès à
      internet et des frais y afférant, étant précisé que Ooftop ne fournit
      aucun moyen matériel ou équipement terminal au Client.
    </p>
    <p>
      <strong>2.2 Accès réservé à la plateforme Ooftop et compte Client</strong>
    </p>
    <p>
      La souscription, l&rsquo;accès ou l&rsquo;utilisation d&rsquo;Ooftop
      nécessite l&rsquo;ouverture d&rsquo;un compte Client impliquant la
      fourniture d&rsquo;un identifiant et le choix d&rsquo;un mot de passe,
      étant précisé que le Client s&rsquo;engage à n&rsquo;ouvrir qu&rsquo;un
      seul compte. L&rsquo;ouverture d&rsquo;un tel compte Client est en
      particulier requise pour le Service Ooftop, ou encore pour le Service de
      demande de réservation d&rsquo;un Expert immobilier. Une fois le compte
      Client créé, ce dernier pourra accéder, via son compte Client, aux
      Services qu&rsquo;il aura commandés.<br />
      Le mot de passe est personnel et confidentiel. Le Client en est seul
      responsable. Il s&rsquo;engage à ne pas le divulguer à des tiers et à
      prendre toutes les précautions nécessaires pour éviter que des tiers
      puissent y avoir accès. Lors de l&rsquo;ouverture de ce compte, le Client
      s&rsquo;engage à fournir des informations exactes, puis à informer sans
      délai Ooftop de tout changement les affectant. Il est expressément
      interdit au Client de créer plusieurs comptes client, notamment en
      renseignant plusieurs identifiants.<br />
      Le Client s&rsquo;engage à avertir sans délai Ooftop par écrit et par tous
      moyens en cas de perte, de détournement, d&rsquo;utilisation frauduleuse
      ou de vol de son identifiant et/ou mot de passe, ou en cas de suspicion de
      fraude concernant lesdits identifiant / mot de passe.<br />
      A défaut, et sauf preuve contraire, toute connexion effectuée après
      authentification sera réputée provenir du Client et sous sa responsabilité
      exclusive. L&rsquo;usage du service d&rsquo;authentification vaut preuve
      de l&rsquo;identité du Client à l&rsquo;occasion de son utilisation du
      Site.<br />
      Le Client peut à tout moment demander la suppression de son compte client
      en adressant un email à info@ooftop.fr.<br />
      Les données du Client hébergées par Ooftop au sein du compte Client sont
      de la seule responsabilité du Client qui s&rsquo;engage à ce que ces
      données et leur usage respectent l&rsquo;ordre public et les droits des
      tiers. A défaut, et si Ooftop a connaissance d&rsquo;une infraction à la
      présente disposition, par application de la Loi n°2004-575 dite pour la
      confiance dans l&rsquo;économie numérique (LCEN), et en sa qualité
      d&rsquo;hébergeur des données du Client, Ooftop est en droit de procéder
      au retrait de toutes données incriminées, éventuellement de suspendre
      l&rsquo;accès du Client à son compte Client sans autres formalités ni
      préavis, nonobstant la faculté qui lui est offerte de résilier pour faute
      le présent Contrat et sans préjudice de la faculté de solliciter la
      réparation du préjudice subi par l&rsquo;allocation de dommages et
      intérêts.
    </p>
    <p>
      Tout Utilisateur ayant accès à internet peut accéder gratuitement et
      depuis n&rsquo;importe où à Ooftop. Les frais supportés par
      l&rsquo;Utilisateur pour y accéder (connexion internet, matériel
      informatique, etc.) ne sont pas à la charge de Ooftop. L&rsquo;utilisation
      de Ooftop et la demande de documents qui y sont proposés seront facturées
      selon les tarifs en vigueur au moment de l&rsquo;utilisation.
    </p>
    <p>
      L&rsquo;ensemble des services sont accessible pour l&rsquo;Utilisateur
      uniquement s&rsquo;il est membre de la plateforme (c&rsquo;est-à-dire
      qu&rsquo;il est identifié à l&rsquo;aide de ses identifiants de
      connexion).<br />
      Le site et ses différents services peuvent être interrompus ou suspendus
      par Ooftop, notamment à l&rsquo;occasion d&rsquo;une maintenance, sans
      obligation de préavis ou de justification.
    </p>
    <p>&nbsp;</p>
    <h2>ARTICLE 4 : Responsabilité de l&rsquo;Utilisateur</h2>
    <p>
      L'Utilisateur est responsable des risques liés à l&rsquo;utilisation de
      son identifiant de connexion et de son mot de passe. Il s&rsquo;engage à
      ne pas communiquer ses accès (login/mot de passe) à un tiers. En cas de
      divulgation de mot de passe, Ooftop décline toute responsabilité.
    </p>
    <p>
      L&rsquo;Utilisateur est responsable de l&rsquo;accès à Ooftop qui lui est
      confié. Il est donc responsable de la gestion de son mot de passe qui doit
      être robuste, c’est-à-dire un mot de passe difficile à retrouver à l’aide
      d’outils automatisés et à deviner par une tierce personne. Ce mot de passe
      peut d’ailleurs être changé à tout moment par l’Utilisateur lui-même via
      le lien dédié à l’intérieur de son compte.<br />La robustesse d'un mot de
      passe est déterminée par sa complexité et sa longueur. L'ANSSI (Agence
      Nationale de la Sécurité des Systèmes d'Information) recommande de choisir
      un mot de passe d'au moins 12 caractères de types différents : majuscules
      ; minuscules ; chiffres et caractères spéciaux. Le mot de passe ne doit
      avoir aucun lien avec l’Utilisateur, c'est-à-dire, qu'il ne doit pas
      inclure le nom, le prénom, la date de naissance, etc …, de l’Utilisateur.
      En tout état de cause, il est important de ne jamais communiquer les mots
      de passe.
    </p>
    <p>
      L&rsquo;Utilisateur est seul responsable (i) de l&rsquo;utilisation
      qu&rsquo;il fait des Services et informations obtenues via Ooftop, (ii) et
      des conséquences directes ou indirectes de cette utilisation. Ooftop ne
      sera aucunement responsable d&rsquo;un quelconque dommage, de quelque
      nature que ce soit, résultant de l&rsquo;utilisation d&rsquo;Ooftop par
      l&rsquo;Utilisateur. Ce dernier garantit Ooftop contre toute demande,
      réclamation, dommage, plainte ou recours en rapport avec une quelconque
      utilisation d&rsquo;Ooftop par l&rsquo;Utilisateur, cette garantie couvre
      tant les dommages et intérêts qui seraient éventuellement versés, quelle
      que soit leur origine directe ou indirecte, que les honoraires
      d&rsquo;avocat, frais d&rsquo;expertise, frais de justice, et frais
      fiscaux.
    </p>
    <p>
      Tout usage du service par l'Utilisateur ayant directement ou indirectement
      pour conséquence des dommages doit faire l'objet d'une indemnisation au
      profit d&rsquo;Ooftop.
    </p>
    <p>&nbsp;</p>
    <h2>ARTICLE 5 : Responsabilité de OOFTOP</h2>
    <p>
      Tout dysfonctionnement de la plateforme ne peut engager la responsabilité
      de OOFTOP.
    </p>
    <p>
      Ooftop se réserve le droit de restreindre ou refuser l&rsquo;accès à tout
      ou partie des Services, unilatéralement et sans notification préalable, à
      tout Utilisateur ne respectant pas les termes du Contrat, ou ne respectant
      pas l&rsquo;ordre public, ou les dispositions législatives et
      règlementaires en vigueur, notamment si Ooftop venait à recevoir toute
      notification par un tiers faisant valoir une atteinte à ses droits, y
      compris des droits de propriété intellectuelle.
    </p>
    <p>
      De manière générale, la responsabilité de Ooftop ne saurait être engagée
      pour un retard ou une défaillance résultant d&rsquo;un cas de force
      majeure, du fait de l&rsquo;Utilisateur, du fait d&rsquo;un tiers, ou
      d&rsquo;un fait extérieur échappant au contrôle de Ooftop.
    </p>
    <p>
      En cas de force majeure, les obligations de la partie empêchée sont
      suspendues, ainsi notamment en cas de : (i) acte ou omission du
      gouvernement ou d&rsquo;autorités supérieures compétentes ; (ii) blocage
      des réseaux de télécommunication ; (iii) insurrections, guerre civile,
      guerre, opérations militaires, état d&rsquo;urgence national ou local,
      feu, foudre, explosion, inondation, tempête, fait d&rsquo;un tiers.
    </p>
    <p>
      Si par extraordinaire la responsabilité de Ooftop était retenue dans
      l&rsquo;exécution du présent Contrat, l&rsquo;Utilisateur ne pourrait
      prétendre à d&rsquo;autres indemnités et dommages et intérêts, que (i) le
      remboursement des paiements qu&rsquo;il a déjà effectués pour la partie du
      Service où se révèle une défaillance ou une erreur imputable à Ooftop (ii)
      le non-paiement de cette partie du Service.
    </p>
    <p>
      Ooftop fait ses meilleurs efforts pour s&rsquo;assurer du bon
      fonctionnement du Site et des Services y figurant. Toutefois, compte tenu
      notamment des aléas techniques liés au fonctionnement décentralisé du
      réseau Internet, Ooftop ne fournit aucune garantie de continuité de
      Service ou d&rsquo;absence d&rsquo;erreurs du Site. Dans ce contexte, il
      appartient à l&rsquo;Utilisateur de protéger ses propres équipements
      terminaux.
    </p>
    <p>
      Les Services présentés par les partenaires, en particulier les Experts
      immobiliers réservés en ligne par l&rsquo;Utilisateur, le sont sous la
      seule responsabilité de ceux-ci. En conséquence de quoi Ooftop est dégagé
      de toute responsabilité du fait des contenus édités et/ou des services
      proposés par les partenaires par l&rsquo;intermédiaire du présent Site.
    </p>
    <p>&nbsp;</p>
    <h2>ARTICLE 6 : Propriété intellectuelle</h2>
    <p>
      6.1 Ooftop ainsi que l&rsquo;ensemble de son contenu (textes, éléments
      graphiques fixes ou animés, sonores, bases de données, logiciels, marques,
      logos…) sont protégés au titre du droit d&rsquo;auteur, du droit des
      marques, du droit sui generis des producteurs de bases de données, et plus
      généralement de la propriété intellectuelle et du droit de la
      responsabilité civile. A ce titre et conformément aux dispositions du Code
      de la Propriété Intellectuelle, seule est autorisée l&rsquo;utilisation
      d&rsquo;Ooftop pour un usage strictement privé et personnel, conformément
      au Contrat liant l&rsquo;Utilisateur et la société commercialisant Ooftop,
      sous réserve de dispositions différentes voire plus restrictives du Code
      de la Propriété Intellectuelle.<br />
      Toute reproduction, exploitation, rediffusion ou utilisation des éléments
      d&rsquo;Ooftop, quelle qu&rsquo;elle soit, est strictement interdite sous
      peine de poursuites, civiles ou pénales. Tout lien simple ou par
      hypertexte, sur Ooftop, est strictement interdit. En aucun cas
      l&rsquo;accès possible aux informations d&rsquo;Ooftop et à certaines
      données, dont notamment via le compte Client, ne peut permettre au Client
      de considérer qu&rsquo;il peut extraire, de manière substantielle ou non,
      et/ou utiliser en dehors de la consultation d&rsquo;Ooftop, une quelconque
      donnée d&rsquo;Ooftop ou de tout élément d&rsquo;Ooftop. Il est rappelé en
      tant que de besoin que de telles extractions et/ou utilisations sont
      strictement interdites.<br />
      En particulier, l&rsquo;extraction, par transfert permanent ou temporaire
      de la totalité ou d&rsquo;une partie qualitativement ou quantitativement
      substantielle du contenu d&rsquo;Ooftop sur un autre support, par tout
      moyen et sous toute forme que ce soit ; ainsi que la réutilisation, par la
      mise à la disposition du public de la totalité ou d&rsquo;une partie
      qualitativement ou quantitativement substantielle du contenu
      d&rsquo;Ooftop, quelle qu&rsquo;en soit la forme sont strictement
      interdites. Il en va de même de l&rsquo;extraction ou de la réutilisation
      répétée et systématique de parties qualitativement ou quantitativement non
      substantielles du contenu d&rsquo;Ooftop.
    </p>
    <p>
      6.2 Il est également interdit de porter une quelconque atteinte à Ooftop
      en tant que système de traitement automatisé de données, en application
      des articles 323-1 et suivants du Code Pénal, notamment par un accès et/ou
      un maintien frauduleux dans tout ou partie d&rsquo;Ooftop ; par le fait
      d&rsquo;entraver ou de fausser son fonctionnement ; ou encore, en
      introduisant frauduleusement des données dans un tel système de traitement
      automatisé de données, en extrayant, en détenant, en reproduisant, en
      transmettant, en supprimant ou en modifiant frauduleusement les données
      contenues dans le Site en tant que système de traitement automatisé de
      données.
    </p>
    <h2>ARTICLE 7 : Données personnelles de l&rsquo;Utilisateur</h2>
    <p>
      L&rsquo;Utilisateur doit obligatoirement fournir des informations
      personnelles pour procéder à son inscription sur la plateforme Ooftop et
      utilisés par Ooftop.
    </p>
    <p>
      Les données personnelles de l&rsquo;Utilisateur sont utilisées par Ooftop,
      en qualité de responsable du traitement de données personnelles et
      transmises à la société qui a commercialisé la solution Ooftop à
      l&rsquo;Utilisateur pour&nbsp;:<br />
      (i) permettre l&rsquo;accès à la plateforme Ooftop ; (ii) assurer la
      gestion de la relation avec l&rsquo;Utilisateur ; (iii) assurer le suivi
      des services commandés ; (iv) permettre la facturation ; (v) développer la
      relation commerciale (marketing) ; (vi) garantir le recouvrement des
      impayés ; (vii) gérer les contentieux éventuels&nbsp;; (viii) assurer
      l&rsquo;administration et la sécurité de la plateforme Ooftop.
    </p>
    <p>
      Les données sont conservées pour la durée nécessaire à
      l&rsquo;accomplissement des finalités susmentionnées ou le temps
      nécessaire pour permettre à Ooftop de répondre à ses obligations
      légales.<br />
      Ces traitements sont légitimes, ou à tout le moins nécessaires à
      l&rsquo;utilisation d&rsquo;Ooftop. Les données ainsi traitées sont
      destinées à IDANS, en particulier aux services commercial, comptable et
      juridique, ainsi qu&rsquo;aux sous-traitants auxquels IDANS est
      susceptible de faire appel dans le cadre de ces traitements. <br />
      Les données relatives à la gestion du client, y compris les données
      relatives à l&rsquo;Utilisateur, sont conservées durant le temps
      strictement nécessaire à la gestion de la relation commerciale ; et plus
      précisément, trois (3) ans à compter de la fin de la relation commerciale.
      Les données de prospects non clients sont conservées trois (3) ans à
      compter de leur collecte ou du dernier contact émanant du prospect.
      Cependant, toutes données permettant d&rsquo;établir la preuve d&rsquo;un
      droit ou d&rsquo;un contrat, ou conservées au titre du respect d&rsquo;une
      obligation légale ou règlementaire, peuvent faire l&rsquo;objet
      d&rsquo;une politique d&rsquo;archivage, et être conservées à cette fin
      conformément aux dispositions légales en vigueur. Les données relatives
      aux logs de connexion de l&rsquo;Utilisateur à Ooftop sont conservées à
      des fins de sécurité, pendant une durée strictement nécessaire à cette
      finalité, et ne pouvant excéder six mois <strong>[A confirmer]</strong>.
      Ces données de connexion sont destinées aux services en charge d'assurer
      la sécurité du Site.
    </p>
    <p>
      L&rsquo;Utilisateur est informé qu'il dispose d'un droit d'accès, de
      rectification, de modification, de portabilité ou d&rsquo;effacement des
      données le concernant. Il peut définir des directives sur le sort de ses
      données après sa mort, demander la limitation du traitement, s&rsquo;y
      opposer, ou le cas échéant retirer son consentement. Pour cela, il peut
      adresser un courriel à
      <a href="mailto:info@ooftop.fr">info@ooftop.fr</a> ou écrire à IDANS
      DIGITAL – OOFTOP – DPO – 12, rue Saint-Fiacre – 75002 Paris.
    </p>
    <p>
      L&rsquo;Utilisateur peut introduire une réclamation auprès d&rsquo;une
      autorité de contrôle
      <a href="https://www.cnil.fr">https://www.cnil.fr</a> Les données
      personnelles ainsi collectées par IDANS sont nécessaires à la gestion des
      clients et prospects d&rsquo;IDANS, à l&rsquo;utilisation d&rsquo;Ooftop.
      Si l&rsquo;Utilisateur ne les renseigne pas, ou s&rsquo;il exerce un droit
      d&rsquo;opposition, de limitation ou d&rsquo;effacement, IDANS ne sera pas
      tenue pour responsable des conséquences qui en découleraient.
    </p>
    <p>&nbsp;</p>
    <h2>ARTICLE 8 : Liens hypertextes</h2>
    <p>
      Les domaines vers lesquels mènent les liens hypertextes présents sur le
      site n&rsquo;engagent pas la responsabilité de Ooftop, qui n&rsquo;a pas
      de contrôle sur ces liens.
    </p>
    <h2>
      ARTICLE 9&nbsp;: Cookies relatives à la solution de valorisation de biens
      immobiliers
    </h2>
    <p>
      Ooftop utilise des cookies pour l&rsquo;utilisation de la solution de
      valorisation de biens immobiliers Ooftop, comme indiqué ci-après&nbsp;:
    </p>
    <p>
      <strong>9.1. Préambule</strong><br />
      Pour permettre aux utilisateurs de bénéficier des services proposés par la
      solution de valorisation de biens immobiliers OOFTOP (ci-après « Ooftop »)
      tels que sa consultation, l&rsquo;optimisation de son utilisation ou sa
      personnalisation en fonction de l&rsquo;utilisateur, Ooftop utilise des
      cookies. Les données personnelles collectées notamment via les cookies par
      Ooftop sont traitées par IDANS DIGITAL (SAS au capital de 5.000 € - 12,
      rue Saint-Fiacre – 75002 Paris – 843&nbsp;534&nbsp;132 RCS Paris)
    </p>
    <p>
      Vous pouvez à tout moment désactiver les cookies auxquels vous avez
      consenti, et ce gratuitement, à partir des possibilités de désactivation
      qui vous sont offertes et rappelées ci-après.
    </p>
    <p>
      <strong>9.2. Définitions</strong><br />
      Les cookies sont des informations relatives à la navigation de votre
      terminal (ordinateur, tablette, smartphone, etc.) sur Ooftop. Ils sont
      utilisés pour envoyer des informations à votre navigateur et permettre à
      ce navigateur de renvoyer des informations à Ooftop (par exemple un
      identifiant de session ou le choix d&rsquo;une langue).
    </p>
    <p>
      Seul l&rsquo;émetteur d&rsquo;un cookie peut lire ou modifier les
      informations qui y sont contenues.
    </p>
    <p>
      Il existe différents types de cookies :<br />
      - des cookies de session qui disparaissent dès que vous quittez Ooftop
      ;<br />
      - des cookies permanents qui demeurent sur votre terminal jusqu&rsquo;à
      expiration de leur durée de vie ou jusqu&rsquo;à ce que vous les
      supprimiez à l&rsquo;aide des fonctionnalités de votre navigateur.<br />
      Vous êtes informés que, lors de vos visites sur Ooftop, des cookies
      peuvent être installés sur votre équipement terminal.
    </p>
    <p><strong>9.3. Finalités et type de cookies utilisés</strong></p>
    <p>
      Le seul cookie utilisé sur la solution de valorisation immobilière Ooftop
      est nécessaire au fonctionnement d&rsquo;Ooftop, sans lesquels
      l&rsquo;expérience de navigation de l&rsquo;utilisateur d&rsquo;Ooftop
      serait fortement dégradée :
    </p>
    <h3>
      Ce Cookie est nécessaire au bon fonctionnement du Site et à sa navigation.
      Il vous permet d&rsquo;accéder aux principales fonctionnalités du Site.
    </h3>
    <table border="0" cellspacing="3" cellpadding="0">
      <tr>
        <td width="158">
          <p><strong>Catégories de cookies</strong></p>
        </td>
        <td width="274">
          <p><strong>Finalité</strong></p>
        </td>
        <td width="139">
          <p><strong>Durée de conservation</strong></p>
        </td>
      </tr>
      <tr>
        <td width="158"><p>Cookie d&rsquo;identifiants de session</p></td>
        <td width="274">
          <p>
            strictement nécessairement au fonctionnement du Site qui a pour
            finalité de maintenir la session du membre suite à son
            identification
          </p>
        </td>
        <td width="139"><p>30 minutes</p></td>
      </tr>
    </table>

    <h3>&nbsp;</h3>
    <h3>
      Conformément aux recommandations de la CNIL, ce cookie est dispensé du
      recueil préalable de votre consentement. Vous pouvez vous y opposer et le
      supprimer en utilisant les paramètres de votre navigateur, cependant vous
      ne pourrez pas avoir accès à l&rsquo;utilisation d&rsquo;Ooftop.
    </h3>
    <strong><br clear="all" /> </strong>
    <p><strong>9.4. Protection des données personnelles</strong></p>
    <p>
      Dans le cadre de l&rsquo;utilisation des cookies telle que décrite
      ci-dessus, Ooftop sera, en tant que responsable du traitement, susceptible
      de traiter des données à caractère personnel vous concernant.
    </p>
    <p>
      Les données collectées sont indispensables pour atteindre les objectifs
      poursuivis par chaque cookie. Elles sont uniquement destinées aux services
      habilités d&rsquo;Ooftop.
    </p>
    <p>
      En application des dispositions du Règlement général sur la protection des
      données, les personnes disposent d&rsquo;un droit d&rsquo;interrogation,
      d&rsquo;accès, de rectification d&rsquo;effacement, d&rsquo;opposition
      pour motifs légitimes et de portabilité relativement à l&rsquo;ensemble
      des données. Pour de plus amples informations, notamment sur
      l&rsquo;exercice de vos droits, reportez-vous à notre Politique de
      protection des données consultable à l&rsquo;adresse suivante
      <a href="https://www.ooftop.fr/donnees-personnelles-cookies/"
        >https://www.ooftop.fr/donnees-personnelles-cookies/</a
      >
    </p>
    <h2>ARTICLE 10 : Évolution des conditions générales d&rsquo;utilisation</h2>
    <p>
      Ooftop se réserve le droit de modifier les clauses de ces conditions
      générales d&rsquo;utilisation à tout moment et sans justification.
    </p>
    <p>&nbsp;</p>
    <h2>ARTICLE 11 : Durée du contrat</h2>
    <p>
      La durée du présent contrat est indéterminée. Le contrat produit ses
      effets à l'égard de l'Utilisateur à compter du début de
      l&rsquo;utilisation du service.
    </p>
    <h2>ARTICLE 12 : Droit applicable et juridiction compétente</h2>
    <p>
      Le présent contrat est soumis au droit français. <br />
      En cas de litige non résolu à l&rsquo;amiable entre l&rsquo;Utilisateur et
      Ooftop, les tribunaux du ressort de l&rsquo;Editeur sont compétents pour
      régler le contentieux.
    </p>
    <p>&nbsp;</p>
  </div>
</template>

<script>
export default {
  name: "CGU",
};
</script>
